/**
 * @created on 2018/11/6
 * @author huangtiande
 **/
import { axios as $http, setHeader } from 'cm'
import './style.scss'
import {
  getRunTime,
  unitConversion,
  getPlatform
} from '../../../public-resource/libs/utils/index'
import api from './api'
import Bridge from '../../../frontend-lib/lib/Bridge'
import { wxConfigOrigin } from 'src/frontend-lib/tools/utils'
import { getEnvHost } from 'src/frontend-lib/tools/getPlatform'
import GetQueryString from '../../../public-resource/get-query/index'
import invitationPoster from '../../../public-resource/components/invitationPoster'
// import vconsole from 'vconsole'
//
// var Vconsole = new vconsole()
;(function() {
  let loading = false
  let UA = window.navigator.userAgent.toUpperCase() // 环境
  let IS_APP = window.$platform.isYixinliApp
  let UAobj = window.$platform

  let tabNum = 0
  let tabPage = [0, 0, 0]
  let tabStatus = [1, 1, 1] // 能否请求
  let tabGetStatus = [1, 1, 1] // 请求状态

  // 初始化引导地图
  let isNewRegister = GetQueryString('invitation')
  if (+isNewRegister === 1) {
    let InvitationPoster = new invitationPoster()
    InvitationPoster.showGuiderMap()
  }

  let loadMore = `<div class="loading-more"><span></span><span></span><span></span></div>`
  if ($('.loading-more').length === 0) {
    $('body').append(loadMore)
  }
  let moreDom = `<div class="more">
  下滑加载更多
</div>`
  $('body').append(moreDom)
  let loadMoreDiv = $('.loading-more')
  window.yxl.stat.send({
    name: '问答-「悬赏区」访问'
  })
  let myBridge = new Bridge()

  $('.pageUl ul').empty()

  window.baseInfo.wx_share.url = window.baseInfo.wx_share.url.replace(
    window.location.protocol + getEnvHost(`//m.xinli001.com`),
    wxConfigOrigin(require('../../../../yxlConfig.json'), 'QA_ORIGIN', 'm_safe')
  )

  // app标题
  if (IS_APP) {
    $('.top-header').remove()
    $('body').addClass('isApp')
    $('.container').css('padding-top', 0)
    myBridge.call('setTitle', {
      title: '悬赏区'
    })
    myBridge.call('topFuncBtnConfig', {
      btnList: [
        {
          name: 'shareReportBtn',
          visible: 1
        }
      ]
    })

    window.myBridge = new Bridge({
      methods: [
        {
          method: 'topFuncBtn',
          callback(ops) {
            if (ops.name === 'shareReportBtn') {
              let $config = {
                link: window.baseInfo.wx_share.url,
                imgUrl: window.baseInfo.wx_share.image,
                desc: window.baseInfo.wx_share.desc,
                title: window.baseInfo.wx_share.title
                // callbackName: 'heaerShareCallBack',
              }
              myBridge.call('shareReport', $config)
            }
          }
        }
      ]
    })
  }

  let HOST = getRunTime('//m.xinli001.com')
  let redirectUrl = `${HOST}/qa`

  function goBack() {
    if (
      navigator.userAgent.indexOf('MSIE') >= 0 &&
      navigator.userAgent.indexOf('Opera') < 0
    ) {
      // IE
      if (history.length > 0) {
        window.history.go(-1)
      } else {
        window.location.href = redirectUrl
      }
    } else {
      // 非IE浏览器
      if (
        navigator.userAgent.indexOf('Firefox') >= 0 ||
        navigator.userAgent.indexOf('Opera') >= 0 ||
        navigator.userAgent.indexOf('Safari') >= 0 ||
        navigator.userAgent.indexOf('Chrome') >= 0 ||
        navigator.userAgent.indexOf('WebKit') >= 0
      ) {
        if (window.history.length > 1) {
          window.history.go(-1)
        } else {
          window.location.href = redirectUrl
        }
      } else {
        // 未知的浏览器
        window.location.href = redirectUrl
      }
    }
  }

  $('.yxl-font-back').click(function() {
    goBack()
  })

  if ($('.ask_btn').length === 0) {
    $('.top-header').append(
      '<span>答疑馆首页</span><div class="ask_btn"><i class="yxlicon icon-askQuetion"></i>提问</div> '
    )
  }
  if (window.history.length < 1 || document.referrer === '') {
    $('.yxl-font-back').hide()
    $('.top-header span').css('color', '#ff745b')
  }

  $('.top-header span').click(function() {
    window.location.href = `${HOST}/qa`
  })

  $('.ask_btn').click(function() {
    window.localStorage.removeItem('invite_user')
    window.location.href = `${HOST}/qa/post-question-view`
  })

  $('.reward_t_t').on('click', function() {
    let href = $(this)
      .children('a')
      .attr('href')
    window.yxl.stat.send({
      name: '问答-悬赏区「顶部活动位」点击'
    })
    window.location.href = href
  })

  let body = document.querySelector('body')
  body.addEventListener('click', function(e) {})
  body.addEventListener('touchend', function(e) {})
  // 置顶功能栏
  let barHeight = Math.ceil($('.reward_t_bar').offset().top)
  let barDom = $('.reward_t_bar')
  $(window).scroll(function() {
    if ($(this).scrollTop() >= barHeight) {
      $('.reward_t_t').css('margin-bottom', '1.97333rem')
      barDom.addClass('fixed_bar')
      if (IS_APP) {
        barDom.addClass('app-fixed_bar')
      }
    } else {
      $('.reward_t_t').css('margin-bottom', '0')
      barDom.removeClass('fixed_bar')
      if (IS_APP) {
        barDom.removeClass('app-fixed_bar')
      }
    }
  })

  let scroll = function() {
    var scrollTop = $(window).scrollTop()
    var scrollHeight = $(document).height()
    var windowHeight = $(window).height()
    if (scrollTop + windowHeight > scrollHeight - 60) {
      let newurl =
        $('.reward_t_bar li')
          .eq(tabNum)
          .attr('data-url') + '&format=json'
      getData(newurl, tabNum)
    }
  }
  // tab切换
  let tabList = $('.reward_t_bar li')
  let page = $('.pageUl')
  tabList.attr('page', '1')
  $('.recommend_reward_qa').attr('page', '2')
  $('.reward_t_bar .recommend_reward_qa').attr('qa-type', 'recommend_reward_qa')
  $('.reward_t_bar .latest_reward_qa').attr('qa-type', 'latest_reward_qa')
  window.addEventListener('scroll', scroll)
  tabList.click(function(event) {
    tabNum = $(this).index()
    $(this)
      .addClass('active')
      .siblings()
      .removeClass('active')
    page
      .eq($(this).index())
      .addClass('active')
      .siblings()
      .removeClass('active')
    let url = $(this).attr('data-url') + '&format=json'
    if ($(this).index() === 1 && tabPage[$(this).index()] === 0) {
      getData(url, $(this).index())
    }
    if (tabStatus[tabNum] === 0) {
      $('.more').html('没有更多')
    } else {
      $('.more').html('下滑加载更多')
    }
  })
  let firstUrl =
    $('.reward_t_bar li')
      .eq(0)
      .attr('data-url') + '&format=json'
  getData(firstUrl, 0)

  function getData(url, index) {
    if (tabStatus[index] === 0 || tabGetStatus[index] === 0) {
      // window.toast('没有更多数据~');
      return
    }
    tabGetStatus[index] = 0
    loadMoreDiv.show()
    $http
      .get(url + '&page=' + (tabPage[index] + 1), { timeout: 20000 })
      .then(res => res.data)
      .then(res => {
        tabGetStatus[index] = 1
        loadMoreDiv.hide()
        if (+res.code === 0) {
          renderLi(res.data, index)
          if (res.data.length < 10) {
            tabStatus[index] = 0
            $('.more').html('没有更多')
          }
          tabPage[index] = tabPage[index] + 1
        } else {
          tabStatus[index] = 0
          $('.more').html('没有更多')
          // window.toast('没有更多数据~');
        }
      })
      .catch(err => {
        tabGetStatus[index] = 1
        loadMoreDiv.hide()
        window.toast(err)
      })
  }

  function renderLi(data, index) {
    data.map(e => {
      let tagHtml = ''
      if (e.second_tags.length > 0) {
        for (var i = 0; i < e.second_tags.length; i++) {
          tagHtml += `<a target="_blank" href='${api.host}/qa/tag_${e.second_tags[i].id}'><span>#${e.second_tags[i].name}</span></a>`
        }
      }
      let liHtml = `<li>
    <div class="list_item_tag_t">
        <div class="list_item_tag">
            ${tagHtml}
        </div>
        <div class="list_item_title">
        <a href="${e.share.url}" target="_blank">${e.title}</a>
        </div>
        <div class="list_item_reward">
            ${
              +e.reward_amount !== 0
                ? `<span>赏金 ¥${(+e.reward_amount / 100).toFixed(2)}</span>`
                : ''
            }
            ${
              +e.platform_reward_amount !== 0
                ? `<span>壹心理追加 ¥${(
                    +e.platform_reward_amount / 100
                  ).toFixed(2)}</span>`
                : ''
            }
        </div>
        <div class="sameFeel_div ${
          +e.is_same_feeling === 1 ? 'has-feel' : ''
        }" data-question_id='${e.id}'>
            <p>
                <span>${e.same_feeling_num}</span>人</p>
            <p>有同感</p>
        </div>
    </div>
    <div class="list_item_tag_b">
        <ul>
            <li class="answer">
                <a href="${e.share.url}" target="_blank">
                    <i class="yxlicon icon-askwrite"></i>我要回答</li>
                </a>
            <li class="follow" data-question_id='${e.id}'>
                <i class="yxlicon ${
                  +e.is_favorite === 1 ? 'icon-instar' : 'icon-unstar'
                }"></i>
                <label>${+e.is_favorite === 1 ? '已关注' : '关注'}</label>
            </li>
            <li class="share" data-title='${e.share.title}' data-cover='${
        e.share.cover
      }' data-desc='${e.share.description}' data-url="${e.share.url}">
                <i class="yxlicon icon-fenxiang"></i>分享</li>
        </ul>
    </div>
</li>`
      $('.pageUl')
        .eq(index)
        .find('ul')
        .eq(0)
        .append(liHtml)
    })
  }

  // 关注
  $(document).delegate('.follow', 'click', function() {
    console.log($(this).attr('data-question_id'))
    let id = $(this).attr('data-question_id')
    $http
      .get(api.storeQuestion + '?question_id=' + id)
      // $http.get(api.storeQuestion + '?question_id=' + id + '&token=' + token)
      .then(res => {
        if (
          $(this)
            .children('i')
            .hasClass('icon-unstar')
        ) {
          $(this)
            .children('i')
            .removeClass('icon-unstar')
          $(this)
            .children('i')
            .addClass('icon-instar')
        } else {
          $(this)
            .children('i')
            .addClass('icon-unstar')
          $(this)
            .children('i')
            .removeClass('icon-instar')
        }
        if (res.data.data.is_store == 1) {
          $(this)
            .children('label')
            .text('已关注')
          window.yxl.stat.send({
            name: '问答-悬赏区「问题内容操作合集」点击',
            properties: {
              操作分类: '关注'
            }
          })
          if (IS_APP) {
            const $dataEl = $(this).siblings('.share')
            const qid = $(this).attr('data-question_id')
            const title = $dataEl.attr('data-title')
            // const cover = $dataEl.attr('data-cover')

            myBridge.call('showRecommendToDynamicDialog', {
              content: '将这条问答推荐到动态吧',
              buttonText: '去推荐',
              object_id: qid,
              object_type: 10,
              object_title: title,
              object_cover:
                'https://ossimg.xinli001.com/logo20190327.png?x-oss-process=image/resize,h_100'
            })
          }
        } else {
          $(this)
            .children('label')
            .text('关注')
        }
        // window.toast(res.data.message)
      })
      .catch(err => window.toast(err))
  })

  // 同感
  $(document).delegate('.sameFeel_div', 'touchend', function(event) {
    console.log($(this).attr('data-question_id'))
    let id = $(this).attr('data-question_id')
    console.log(
      $(this)
        .children('p')
        .children('span')
        .text()
    )
    // $http.get(api.sameFeel + '?question_id=' + id)
    $http
      .get(api.sameFeel + '?question_id=' + id)
      .then(res => res.data)
      .then(res => {
        let feelNumber = parseInt(
          $(this)
            .children('p')
            .children('span')
            .text()
        )
        if (+res.code === 0) {
          if (+res.data.is_same_feeling === 0) {
            feelNumber = feelNumber - 1 < 0 ? 0 : feelNumber - 1
            $(this)
              .children('p')
              .children('span')
              .text(unitConversion(feelNumber))
            $(this).removeClass('has-feel')
          } else {
            feelNumber = feelNumber + 1 < 0 ? 0 : feelNumber + 1
            $(this)
              .children('p')
              .children('span')
              .text(unitConversion(feelNumber))
            $(this).addClass('has-feel')
          }
        } else {
          window.toast(res.data.message)
        }
      })
      .catch(err => window.toast(err))
  })

  // let UA = window.navigator.userAgent.toUpperCase();
  window.shareForApp = function() {
    let shareConfig = {
      name: '问答-悬赏区「问题内容操作合集」点击',
      properties: {
        操作分类: '分享'
      }
    }
    myBridge.call('stat', shareConfig)
  }
  $(document).delegate('.share', 'click', function() {
    let title = $(this).attr('data-title') || '壹心理-悬赏问答'
    let objectTitle = $(this)
      .parents('li')
      .find('.list_item_title')
      .text()
    let cover =
      $(this).attr('data-cover') ||
      'http://lapp-box5.xinli001.com/images/website-mobile/qa_logo.jpg'
    let desc = $(this).attr('data-desc') || '心理互助与心理学人交流成长的社区'
    let dataUrl = $(this).attr('data-url') || window.location.href
    if (IS_APP) {
      const qid = $(this)
        .siblings('.follow')
        .attr('data-question_id')
      console.log('动态分享', {
        title: title,
        desc: desc,
        link: dataUrl,
        imgUrl: cover,
        callbackName: 'shareForApp',
        // 动态分享的字段
        isShowDynamic: 1,
        object_id: qid,
        object_type: 10, // 10 表示提问
        object_title: objectTitle,
        object_cover:
          'https://ossimg.xinli001.com/logo20190327.png?x-oss-process=image/resize,h_100'
      })
      let share_config = {
        title: title,
        desc: desc,
        link: dataUrl,
        imgUrl: cover,
        callbackName: 'shareForApp',
        // 动态分享的字段
        isShowDynamic: 1,
        object_id: qid,
        object_type: 10, // 10 表示提问
        object_title: objectTitle,
        object_cover:
          'https://ossimg.xinli001.com/logo20190327.png?x-oss-process=image/resize,h_100'
      }
      if (UAobj.isiPhone) {
        share_config.title = encodeURIComponent(share_config.title)
        share_config.desc = encodeURIComponent(share_config.desc)
      }
      myBridge.call('shareReport', share_config)
    } else {
      window.yxl.stat.send({
        name: '问答-悬赏区「问题内容操作合集」点击',
        properties: {
          操作分类: '分享'
        }
      })
      window.open(dataUrl + '?is_share=true')
      // window.location.href = dataUrl + '?is_share=true';
    }
    console.log(title, cover, desc)
  })

  $(document).delegate('.go_reply', 'click', function(e) {
    e.preventDefault()
    let href = $(this)
      .children('a')
      .attr('href')
    window.yxl.stat.send({
      name: '问答-悬赏区「问题内容操作合集」点击',
      properties: {
        操作分类: '我要回答'
      }
    })
    window.open(href, '_blank')
  })

  if (window.$platform.isWechat) {
    let currentUrl = document.location.href
    let getWxConfig = api.getWXShareConfig
    let title = window.baseInfo.wx_share.title
    let cover = window.baseInfo.wx_share.image
    let desc = window.baseInfo.wx_share.desc
    let dataUrl = window.baseInfo.wx_share.url
    $http
      .get(getWxConfig + '?url=' + encodeURIComponent(currentUrl))
      .then(res => {
        if (res.data.code == 0) {
          var wxConfig = res.data.data

          function loadScript(url, callback) {
            var script = document.createElement('script')
            script.type = 'text/javascript'
            if (typeof callback !== 'undefined') {
              if (script.readyState) {
                script.onreadystatechange = function() {
                  if (
                    script.readyState == 'loaded' ||
                    script.readyState == 'complete'
                  ) {
                    script.onreadystatechange = null
                    callback()
                  }
                }
              } else {
                script.onload = function() {
                  callback()
                }
              }
            }
            script.src = url
            document.body.appendChild(script)
          }

          setTimeout(() => {
            loadScript('//res.wx.qq.com/open/js/jweixin-1.6.0.js', () => {
              var _config = {
                debug: wxConfig.debug,
                appId: wxConfig.appId,
                timestamp: wxConfig.timestamp,
                nonceStr: wxConfig.nonceStr,
                signature: wxConfig.signature,
                jsApiList: [
                  'onMenuShareTimeline',
                  'onMenuShareAppMessage',
                  'onMenuShareQQ',
                  'onMenuShareWeibo',
                  'onMenuShareQZone',
                  'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
                  'updateTimelineShareData' // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              }

              // 微信基本配置信息
              wx.config(_config)
              wx.ready(function() {
                var shareConfig = {
                  title: title,
                  desc: desc,
                  link: dataUrl,
                  imgUrl: cover,
                  success: function(res) {},
                  cancel: function(res) {},
                  fail: function(res) {}
                }
                // let tempConfig = window.baseInfo.wx_share_config;
                // tempConfig.imgUrl = tempConfig.cover;
                // tempConfig.link = tempConfig.url;
                // var shareConfig = tempConfig;
                // 分享到朋友圈
                wx.onMenuShareTimeline(shareConfig)
                // 分享给朋友
                wx.onMenuShareAppMessage(shareConfig)
                // 分享到QQ
                wx.onMenuShareQQ(shareConfig)
                // 分享到腾讯微博
                wx.onMenuShareWeibo(shareConfig)
                // 分享到QQ空间
                wx.onMenuShareQZone(shareConfig)
                wx.updateAppMessageShareData(shareConfig)
                wx.updateTimelineShareData(shareConfig)
              })
            })
          }, 500)
        }
      })
  }
})()



// WEBPACK FOOTER //
// ./src/pages/ask/rewardArea/index.js